import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import history from '../../history';
import ReactTable from 'react-table';
import {
  fetchCustomTemplatesRequest,
  setActiveRaCustomTemplate
} from '../../actions/jsa';
import { updateLeftNavRequest } from '../../actions/navigation';
import { getLoggedInUser } from '../../selectors/users';
import { getCustomRaTemplatesSelector } from '../../selectors/jsa';
import {
  defaultFilterMethod,
  defaultSortMethod,
  filterHireDate,
  sortDateMethod
} from '../../utils/sortFilterHelpers';
import Header from '../../components/Header';
import Button from '../../components/inputs/Button';

import './index.css';

export class CustomRaList extends Component {
  componentDidMount() {
    this.props.updateLeftNav('Custom Risk Assessments');
    this.props.fetchCustomTemplates();
  }

  render() {
    const { templates, setActiveCustomTemplate } = this.props;

    return (
      <div className="customRaList">
        <Header
          title="Custom Risk Assessments"
          rightButtons={{
            text: 'Create Template',
            color: 'blue',
            onClick: () =>
              setActiveCustomTemplate({}) &&
              history.push('/app/customRaContainer')
          }}
        />
        <div className="customRaList-table">
          <ReactTable
            data={templates}
            filterable
            resizable={false}
            defaultSortMethod={(a, b) => defaultSortMethod(a, b)}
            defaultFilterMethod={(filter, row) =>
              defaultFilterMethod(filter, row)
            }
            columns={[
              {
                Header: 'TITLE',
                accessor: d => d.title,
                id: 'title'
              },
              {
                Header: 'DESCRIPTION',
                accessor: d => d.description,
                id: 'description'
              },
              {
                Header: 'UPDATED DATE',
                accessor: 'updatedDate',
                Cell: row => `${moment(row.updatedAt).format('MM/DD/YYYY')}`,
                sortMethod: (a, b) => sortDateMethod(a, b),
                filterMethod: (filter, row) => filterHireDate(filter, row),
                Filter: ({ filter, onChange }) => (
                  <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: '100%' }}
                    value={filter ? filter.value : 'All Folders'}
                  >
                    <option value="all">Show All</option>
                    <option value="past7">Past 7 Days</option>
                    <option value="past30">Past 30 Days</option>
                    <option value="past60">Past 60 Days</option>
                    <option value="past90">Past 90 Days</option>
                    <option value="past120">More Than 90 Days</option>
                  </select>
                )
              },
              {
                Header: 'VIEW/EDIT',
                Cell: row => (
                  <Button
                    onClick={() => {
                      setActiveCustomTemplate(row.original);
                      history.push('/app/customRaContainer');
                    }}
                    text="View/Edit"
                    color="blue"
                  />
                ),
                filterable: false,
                sortable: false
              }
            ]}
            noDataText="No results found"
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  templates: getCustomRaTemplatesSelector(state),
  loggedInUser: getLoggedInUser(state)
});

const mapDispatchToProps = dispatch => ({
  updateLeftNav: navigation => dispatch(updateLeftNavRequest(navigation)),
  fetchCustomTemplates: () => dispatch(fetchCustomTemplatesRequest()),
  setActiveCustomTemplate: payload =>
    dispatch(setActiveRaCustomTemplate(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomRaList);
